import { useNavigate } from "react-router";
import { useFavouriteLike } from "../../actions/dashboardActions";
export default () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const {
    data: newsFavouriteData,
    isLoading,
    isError,
    error,
  } = useFavouriteLike(userId, "news");
  console.log("newsFavouriteData", newsFavouriteData);

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading news: {error.message}</p>
      </div>
    );
  }
  const handleNews = (id) => {
    navigate(`/news-details/${id}`);
  };
  return { newsFavouriteData, isLoading, handleNews };
};
